import { ReactNode } from 'react';

import { MarkLinkComponent } from './MarkLinkComponent';

interface MarkLinkProps {
  linktype?: string;
  href?: string;
  target?: string;
  anchor?: string;
  uuid?: string;
}

/**
 * This function creates a StoryblokLink object from provided props and returns an Anchor component
 * with link properties obtained from the StoryblokLink object.
 * @param {ReactNode} children - ReactNode, which is a type for any valid React child element, such as
 * a string, number, or JSX element.
 * @param {MarkLinkProps} props - The `props` parameter is an object that contains the following
 * properties:
 * @returns The `markLink` function returns a JSX element that renders an `Anchor` component with the
 * `linkProps` obtained from the `getLinkPropsFromStoryblok` function, and the `children` passed as a
 * parameter.
 */
export const MarkLink = (
  children: ReactNode,
  { linktype, href, target, anchor, uuid }: MarkLinkProps,
) => {
  return (
    <MarkLinkComponent anchor={anchor} href={href} linktype={linktype} target={target} uuid={uuid}>
      {children}
    </MarkLinkComponent>
  );
};
